import React from 'react';
import Dropdown from './Dropdown'
import Toggler from './Toggler'
import * as d3 from "./d3.modified.js"

export default class UberNode extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: this.props.data
        }

        this.props.data._styleMove = this.styleMove
    }

    componentDidMount() {
        var node = this.props.data

        // attach input and its behavior
        if (node.hasInput && node._refs.input) {
            // node._refs.input.attr('transform', `translate(${node.x} ${node.y+node.bb.height/2})`)
            node.inputX = 0
            node.inputY = node.bb.height/2
            node._refs.input
                .on('click', ()=>{
                    d3.event.stopPropagation()

                    if (this.props.event.endNode === undefined) {
                        if (this.props.event.startNode) {
                            // vec postoji pocetni -> pokusaj da napravis link
                            var canLink = this.props.testLinkage(this.props.event.startNode.id, node.id, true)
                            if (canLink) {
                                this.props.event.startNode._refs.output.classed('io-selected', false)
                                this.props.event.endNode = node
                                this.props.createLink()
                            } else {
                                this.props.event.startNode._refs.output.classed('io-selected', false)
                                this.props.event.startNode = undefined
                            }
                        } else {
                            // ne postoji pocetni -> samo ovaj kraj oznaci kao da je aktivan za crtanje linka
                            this.props.event.endNode = node
                            node._refs.input.classed('io-selected', true)
                        }
                    }
                })
                .on('mouseenter', ()=>{
                    if (this.props.event.endNode === undefined) {
                        if (this.props.event.startNode === undefined) {
                            node._refs.input.classed('io-available', true)
                        } else {
                            (this.props.testLinkage(this.props.event.startNode.id, node.id, true))
                                ? node._refs.input.classed('io-available', true)
                                : node._refs.input.classed('io-unavailable', true)
                        }
                    } else {
                        node._refs.input.classed('io-unavailable', true)
                    }
                })
                .on('mouseleave', ()=>{
                    node._refs.input.classed('io-available', false)
                    node._refs.input.classed('io-unavailable', false)
                })
        }

        // attach output and its behavior
        if (node.hasOutput && node._refs.output) {
            // node._refs.output.attr('transform', `translate(${node.x+node.bb.width} ${node.y+node.bb.height/2})`)
            node.outputX = node.bb.width
            node.outputY = node.bb.height/2
            node._refs.output
                .on('click', ()=>{
                    d3.event.stopPropagation()

                    if (this.props.event.startNode === undefined) {
                        if (this.props.event.endNode) {
                            // vec postoji i kraj -> pokusaj da napravis link
                            var canLink = this.props.testLinkage(node.id, this.props.event.endNode.id, true)
                            if (canLink) {
                                this.props.event.endNode._refs.input.classed('io-selected', false)
                                this.props.event.startNode = node
                                this.props.createLink()
                            } else {
                                this.props.event.endNode._refs.input.classed('io-selected', false)
                                this.props.event.endNode = undefined
                            }
                        } else {
                            // ne postoji krajnji -> samo ovaj kraj oznaci kao da je aktivan za crtanje linka
                            this.props.event.startNode = node
                            node._refs.output.classed('io-selected', true)
                        }
                    }
                })
                .on('mouseenter', ()=>{
                    if (this.props.event.startNode === undefined) {
                        if (this.props.event.endNode === undefined) {
                            node._refs.output.classed('io-available', true)
                        } else {
                            (this.props.testLinkage(node.id, this.props.event.endNode.id, true))
                                ? node._refs.output.classed('io-available', true)
                                : node._refs.output.classed('io-unavailable', true)
                        }
                    } else {
                        node._refs.output.classed('io-unavailable', true)
                    }
                })
                .on('mouseleave', ()=>{
                    node._refs.output.classed('io-available', false)
                    node._refs.output.classed('io-unavailable', false)
                })
        }

        // position entire node
        // node._refs.holder.attr('transform', `translate(${node.x} ${node.y})`)
        node._refs.fobj.attr('x', node.x)
        node._refs.fobj.attr('y', node.y)

        // node._refs.dragBtn.on('mousedown', ()=>{
        //     this.canDrag = true
        // })

        // drag behavior
        node._refs.dragBtn.call(d3.drag()
            .container(function() {
                return this.parentNode.parentNode   // black magic, fuck me if i know why/how it works
            })
            .on("start", ()=>{
                // if (true!==this.canDrag) {
                //     return
                // }

                // node._refs.closeBtn.classed('btnInvisible', true)
                node._refs.dragBtn.classed('btnVisible', true)

                this.startDragMPosX = d3.event.x
                this.startDragMPosY = d3.event.y
                this.startDragPosX = node.x
                this.startDragPosY = node.y
            })
            .on("drag", ()=>{
                // if (true!==this.canDrag) {
                //     return
                // }
                // node.x += d3.event.dx
                // node.y += d3.event.dy
                node.x = this.startDragPosX + (d3.event.x-this.startDragMPosX)
                node.y = this.startDragPosY + (d3.event.y-this.startDragMPosY)
                const _step = 10
                node.x = parseInt((node.x+_step/2)/_step)*_step
                node.y = parseInt((node.y+_step/2)/_step)*_step
                node.x = node.x<0?0:node.x
                node.y = node.y<5?5:node.y
                this.props.moveNode(node)
            })
            .on("end", ()=>{
                this.canDrag = false
                // node._refs.closeBtn.classed('btnInvisible', false)
                node._refs.dragBtn.classed('btnVisible', false)
            })
        )

        node._refs.holder
            .on('mousemove', ()=>{
                d3.event.stopPropagation()
            })
            .on('mousedown', ()=>{
                d3.event.stopPropagation()
            })
            .on('mouseup', ()=>{
                d3.event.stopPropagation()
            })
            .on('dblclick', ()=>{
                d3.event.stopPropagation()
            })

        if (node._refs.textInput) {
            node._refs.textInput
                .on('keydown', ()=>{
                    d3.event.stopPropagation()
                    // // 'Tab' button
                    // if (9===d3.event.keyCode) {
                    //     this.props.data.links.forEach(
                    //         linkId => {

                    //         }
                    //     )
                    //     // 'Shift' + 'Tab'
                    //     if (d3.event.shiftKey) {

                    //     }
                    // }
                })
                .on('keyup', ()=>{
                    d3.event.stopPropagation()
                })
        }

        node._refs.closeBtn.on('click', ()=>{
            d3.event.stopPropagation()
            this.props.removeNode(node.id)
        })


    }

    // focusForInput = () => {
    //     var node = this.props.data
    //     if (node._refs.textInput) {
    //         node._refs.textInput.focus()
    //     }
    // }

    styleMove = (dx, dy) => {
        var node = this.props.data

        if (node._refs.fobj) {
            node._refs.fobj.attr('x', node.x)
            node._refs.fobj.attr('y', node.y)
        }
    }

    render() {

        var node = this.props.data
        node._refs = {}

        var inputJSX = (this.props.data.hasInput)
                            ?   <div
                                    ref={c=>node._refs.input=d3.select(c)}
                                    className="uber-node-io input"
                                ></div>
                            : null
        var outputJSX = (this.props.data.hasOutput)
                            ?   <div
                                    ref={c=>node._refs.output=d3.select(c)}
                                    className="uber-node-io output"
                                ></div>
                            : null

        var closeBtnJSX = (
            <div className="closeBtn btnbtn" ref={c=>node._refs.closeBtn=d3.select(c)} title="Remove">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                    <path d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z"></path>
                </svg>
            </div>
        )

        var dragBtnJSX = (
            <div className="dragBtn btnbtn" ref={c=>node._refs.dragBtn=d3.select(c)} title="Drag to move">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                    <path d="M18.354 10.146l-3-3c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2.146 2.146h-6.793v-6.793l2.146 2.146c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-3-3c-0.195-0.195-0.512-0.195-0.707 0l-3 3c-0.195 0.195-0.195 0.512 0 0.707s0.512 0.195 0.707 0l2.146-2.146v6.793h-6.793l2.146-2.146c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-3 3c-0.195 0.195-0.195 0.512 0 0.707l3 3c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-2.146-2.146h6.793v6.793l-2.146-2.146c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l3 3c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l3-3c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-2.146 2.146v-6.793h6.793l-2.146 2.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l3-3c0.195-0.195 0.195-0.512 0-0.707z"></path>
                </svg>
            </div>
        )

        var bb = (this.props.data.bb = {width: 150, height: 30})
        switch (this.props.data.type) {
            case 'match':
                bb.width=265
                return (
                    <g
                        ref={c=>node._refs.holder=d3.select(c)}
                        className="uber-node-holder"
                    >
                        <foreignObject
                            x={node.x} y={node.y}
                            width={bb.width+40}
                            height={bb.height+40}
                            ref={c=>node._refs.fobj=d3.select(c)}
                        >
                            <div className="uber-node-holder">
                                <Dropdown
                                    nostyle
                                    values={this.props.templatesFieldList}
                                    default={this.props.data.fieldName}
                                    onChange={val=>{this.props.data.fieldName = val; this.setState({data: this.props.data}, ()=>{this.props.executeSearch()})}}
                                />
                                <input
                                    ref={c=>node._refs.textInput=d3.select(c)}
                                    spellCheck="false"
                                    type="text"
                                    xmlns="http://www.w3.org/1999/xhtml"
                                    placeholder="Search string..."
                                    value={this.state.data.value}
                                    onChange={e=>{this.props.data.value=e.target.value; this.setState({data: this.props.data}, ()=>{this.props.executeSearch()})}}
                                />
                                <span
                                    className={"invert"+(this.props.data.invert?' active':'')}
                                    title="Invert match"
                                    onClick={()=>{
                                        this.props.data.invert=!this.props.data.invert;
                                        this.setState({data: this.props.data}, ()=>{this.props.executeSearch()})
                                    }}>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                        <path d="M19.854 8.646c-0.195-0.195-0.512-0.195-0.707 0l-1.149 1.149c-0.051-2.060-0.878-3.99-2.341-5.452-1.511-1.511-3.52-2.343-5.657-2.343-2.974 0-5.686 1.635-7.077 4.266-0.129 0.244-0.036 0.547 0.208 0.676s0.547 0.036 0.676-0.208c1.217-2.303 3.59-3.734 6.193-3.734 3.789 0 6.885 3.027 6.997 6.789l-1.143-1.143c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2 2c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2-2c0.195-0.195 0.195-0.512 0-0.707z"></path>
                                        <path d="M16.869 13.058c-0.244-0.129-0.547-0.036-0.676 0.208-1.217 2.303-3.59 3.734-6.193 3.734-3.789 0-6.885-3.027-6.997-6.789l1.143 1.143c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-2-2c-0.195-0.195-0.512-0.195-0.707 0l-2 2c-0.195 0.195-0.195 0.512 0 0.707s0.512 0.195 0.707 0l1.149-1.149c0.051 2.060 0.878 3.99 2.341 5.452 1.511 1.511 3.52 2.343 5.657 2.343 2.974 0 5.686-1.635 7.077-4.266 0.129-0.244 0.036-0.547-0.208-0.676z"></path>
                                    </svg>
                                </span>
                                {dragBtnJSX}
                                {closeBtnJSX}
                                {inputJSX}
                                {outputJSX}
                            </div>
                        </foreignObject>
                    </g>
                )
                break
            case 'union':
                bb.width=60
                return (
                    <g
                        ref={c=>node._refs.holder=d3.select(c)}
                        className="uber-node-holder"
                    >
                        <foreignObject
                            x={node.x} y={node.y}
                            width={bb.width+40}
                            height={bb.height+40}
                            ref={c=>node._refs.fobj=d3.select(c)}
                        >
                            <div className="uber-node-holder union">
                                {/*<span style={{width: "20px", display: "inline-block"}}>U</span>*/}
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 37.5" version="1.1" x="0px" y="0px" width="28" height="28" className="push">
                                    <g stroke="#888" strokeWidth="0.2" fill="none" fillRule="evenodd">
                                        <g transform="translate(-45.000000, -180.000000)" fill="#888">
                                            <path d="M47.5004358,190 L55,190 L55,182.500436 C55,182.224053 55.2275865,182 55.5002097,182 L72.4997903,182 C72.7760485,182 73,182.227587 73,182.50021 L73,199.49979 C73,199.776048 72.7692032,200 72.4995642,200 L65,200 L65,207.499564 C65,207.775947 64.7724135,208 64.4997903,208 L47.5002097,208 C47.2239515,208 47,207.772413 47,207.49979 L47,190.50021 C47,190.223952 47.2307968,190 47.5004358,190 Z M55.4995642,191 C55.7759472,191 56,190.769203 56,190.499564 L56,183 L72,183 L72,199 L64.5004358,199 C64.2240528,199 64,199.230797 64,199.500436 L64,207 L48,207 L48,191 L55.4995642,191 Z M64.5,194 C64.7761424,194 65,194.214035 65,194.504684 L65,196.495316 C65,196.774045 64.7680664,197 64.5,197 C64.2238576,197 64,196.785965 64,196.495316 L64,194.504684 C64,194.225955 64.2319336,194 64.5,194 Z M60.4953156,191 L58.5046844,191 C58.2259549,191 58,190.768066 58,190.5 C58,190.223858 58.214035,190 58.5046844,190 L60.4953156,190 C60.7740451,190 61,190.231934 61,190.5 C61,190.776142 60.785965,191 60.4953156,191 Z M64.5,192 C64.2238576,192 64,191.768066 64,191.5 L64,191 L63.5,191 C63.2238576,191 63,190.768066 63,190.5 C63,190.223858 63.214035,190 63.5046844,190 L64.4953156,190 C64.7740451,190 65,190.214035 65,190.504684 L65,191.495316 C65,191.774045 64.7680664,192 64.5,192 Z M55.5,196 C55.2238576,196 55,195.785965 55,195.495316 L55,193.504684 C55,193.225955 55.2319336,193 55.5,193 C55.7761424,193 56,193.214035 56,193.504684 L56,195.495316 C56,195.774045 55.7680664,196 55.5,196 Z M59.5046844,199 L61.4953156,199 C61.7740451,199 62,199.231934 62,199.5 C62,199.776142 61.785965,200 61.4953156,200 L59.5046844,200 C59.2259549,200 59,199.768066 59,199.5 C59,199.223858 59.214035,199 59.5046844,199 Z M55.5,198 C55.7761424,198 56,198.231934 56,198.5 L56,199 L56.5,199 C56.7761424,199 57,199.231934 57,199.5 C57,199.776142 56.785965,200 56.4953156,200 L55.5046844,200 C55.2259549,200 55,199.785965 55,199.495316 L55,198.504684 C55,198.225955 55.2319336,198 55.5,198 Z"/>
                                        </g>
                                    </g>
                                </svg>
                                {dragBtnJSX}
                                {closeBtnJSX}
                                {inputJSX}
                                {outputJSX}
                            </div>
                        </foreignObject>
                    </g>
                )
                break
            case 'intersect':
                bb.width=60
                return (
                    <g
                        ref={c=>node._refs.holder=d3.select(c)}
                        className="uber-node-holder"
                    >
                        <foreignObject
                            x={node.x} y={node.y}
                            width={bb.width+40}
                            height={bb.height+40}
                            ref={c=>node._refs.fobj=d3.select(c)}
                        >
                            <div className="uber-node-holder intersect">
                                <svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 30 37.5" version="1.1" x="0px" y="0px" width="28" height="28" className="push">
                                    <g stroke="#888" strokeWidth="0.4" fill="none" fillRule="evenodd">
                                        <g transform="translate(-135.000000, -180.000000)" fill="#888">
                                            <path d="M145.50965,190 L154.49035,190 C154.771822,190 155,190.227653 155,190.50965 L155,199.49035 C155,199.771822 154.772347,200 154.49035,200 L145.50965,200 C145.228178,200 145,199.772347 145,199.49035 L145,190.50965 C145,190.228178 145.227653,190 145.50965,190 Z M154,191 L154,199 L146,199 L146,191 L154,191 Z M145.5,186 C145.776142,186 146,186.214035 146,186.504684 L146,187.495316 C146,187.774045 145.768066,188 145.5,188 C145.223858,188 145,187.785965 145,187.495316 L145,186.504684 C145,186.225955 145.231934,186 145.5,186 Z M162.5,186 C162.776142,186 163,186.214035 163,186.504684 L163,187.495316 C163,187.774045 162.768066,188 162.5,188 C162.223858,188 162,187.785965 162,187.495316 L162,186.504684 C162,186.225955 162.231934,186 162.5,186 Z M162.5,190 C162.776142,190 163,190.214035 163,190.504684 L163,191.495316 C163,191.774045 162.768066,192 162.5,192 C162.223858,192 162,191.785965 162,191.495316 L162,190.504684 C162,190.225955 162.231934,190 162.5,190 Z M162.5,194 C162.776142,194 163,194.214035 163,194.504684 L163,195.495316 C163,195.774045 162.768066,196 162.5,196 C162.223858,196 162,195.785965 162,195.495316 L162,194.504684 C162,194.225955 162.231934,194 162.5,194 Z M154.5,202 C154.776142,202 155,202.214035 155,202.504684 L155,203.495316 C155,203.774045 154.768066,204 154.5,204 C154.223858,204 154,203.785965 154,203.495316 L154,202.504684 C154,202.225955 154.231934,202 154.5,202 Z M150.495316,183 L149.504684,183 C149.225955,183 149,182.768066 149,182.5 C149,182.223858 149.214035,182 149.504684,182 L150.495316,182 C150.774045,182 151,182.231934 151,182.5 C151,182.776142 150.785965,183 150.495316,183 Z M154.495316,183 L153.504684,183 C153.225955,183 153,182.768066 153,182.5 C153,182.223858 153.214035,182 153.504684,182 L154.495316,182 C154.774045,182 155,182.231934 155,182.5 C155,182.776142 154.785965,183 154.495316,183 Z M158.495316,183 L157.504684,183 C157.225955,183 157,182.768066 157,182.5 C157,182.223858 157.214035,182 157.504684,182 L158.495316,182 C158.774045,182 159,182.231934 159,182.5 C159,182.776142 158.785965,183 158.495316,183 Z M145.5,184 C145.776142,184 146,183.768066 146,183.5 L146,183 L146.5,183 C146.776142,183 147,182.768066 147,182.5 C147,182.223858 146.785965,182 146.495316,182 L145.504684,182 C145.225955,182 145,182.214035 145,182.504684 L145,183.495316 C145,183.774045 145.231934,184 145.5,184 Z M162.5,184 C162.223858,184 162,183.768066 162,183.5 L162,183 L161.5,183 C161.223858,183 161,182.768066 161,182.5 C161,182.223858 161.214035,182 161.504684,182 L162.495316,182 C162.774045,182 163,182.214035 163,182.504684 L163,183.495316 C163,183.774045 162.768066,184 162.5,184 Z M162.5,198 C162.223858,198 162,198.231934 162,198.5 L162,199 L161.5,199 C161.223858,199 161,199.231934 161,199.5 C161,199.776142 161.214035,200 161.504684,200 L162.495316,200 C162.774045,200 163,199.785965 163,199.495316 L163,198.504684 C163,198.225955 162.768066,198 162.5,198 Z M154.5,206 C154.223858,206 154,206.231934 154,206.5 L154,207 L153.5,207 C153.223858,207 153,207.231934 153,207.5 C153,207.776142 153.214035,208 153.504684,208 L154.495316,208 C154.774045,208 155,207.785965 155,207.495316 L155,206.504684 C155,206.225955 154.768066,206 154.5,206 Z M137.5,206 C137.776142,206 138,206.231934 138,206.5 L138,207 L138.5,207 C138.776142,207 139,207.231934 139,207.5 C139,207.776142 138.785965,208 138.495316,208 L137.504684,208 C137.225955,208 137,207.785965 137,207.495316 L137,206.504684 C137,206.225955 137.231934,206 137.5,206 Z M137.5,194 C137.776142,194 138,194.214035 138,194.504684 L138,195.495316 C138,195.774045 137.768066,196 137.5,196 C137.223858,196 137,195.785965 137,195.495316 L137,194.504684 C137,194.225955 137.231934,194 137.5,194 Z M137.5,198 C137.776142,198 138,198.214035 138,198.504684 L138,199.495316 C138,199.774045 137.768066,200 137.5,200 C137.223858,200 137,199.785965 137,199.495316 L137,198.504684 C137,198.225955 137.231934,198 137.5,198 Z M137.5,202 C137.776142,202 138,202.214035 138,202.504684 L138,203.495316 C138,203.774045 137.768066,204 137.5,204 C137.223858,204 137,203.785965 137,203.495316 L137,202.504684 C137,202.225955 137.231934,202 137.5,202 Z M142.495316,191 L141.504684,191 C141.225955,191 141,190.768066 141,190.5 C141,190.223858 141.214035,190 141.504684,190 L142.495316,190 C142.774045,190 143,190.231934 143,190.5 C143,190.776142 142.785965,191 142.495316,191 Z M142.495316,208 L141.504684,208 C141.225955,208 141,207.768066 141,207.5 C141,207.223858 141.214035,207 141.504684,207 L142.495316,207 C142.774045,207 143,207.231934 143,207.5 C143,207.776142 142.785965,208 142.495316,208 Z M146.495316,208 L145.504684,208 C145.225955,208 145,207.768066 145,207.5 C145,207.223858 145.214035,207 145.504684,207 L146.495316,207 C146.774045,207 147,207.231934 147,207.5 C147,207.776142 146.785965,208 146.495316,208 Z M150.495316,208 L149.504684,208 C149.225955,208 149,207.768066 149,207.5 C149,207.223858 149.214035,207 149.504684,207 L150.495316,207 C150.774045,207 151,207.231934 151,207.5 C151,207.776142 150.785965,208 150.495316,208 Z M158.495316,200 L157.504684,200 C157.225955,200 157,199.768066 157,199.5 C157,199.223858 157.214035,199 157.504684,199 L158.495316,199 C158.774045,199 159,199.231934 159,199.5 C159,199.776142 158.785965,200 158.495316,200 Z M137.5,192 C137.776142,192 138,191.768066 138,191.5 L138,191 L138.5,191 C138.776142,191 139,190.768066 139,190.5 C139,190.223858 138.785965,190 138.495316,190 L137.504684,190 C137.225955,190 137,190.214035 137,190.504684 L137,191.495316 C137,191.774045 137.231934,192 137.5,192 Z"/>
                                        </g>
                                    </g>
                                </svg>
                                {dragBtnJSX}
                                {closeBtnJSX}
                                {inputJSX}
                                {outputJSX}
                            </div>
                        </foreignObject>
                    </g>
                )
                break
            case 'link':
                bb.width=90
                return (
                    <g
                        ref={c=>node._refs.holder=d3.select(c)}
                        className="uber-node-holder"
                    >
                        <foreignObject
                            x={node.x} y={node.y}
                            width={bb.width+40}
                            height={bb.height+40}
                            ref={c=>node._refs.fobj=d3.select(c)}
                        >
                            <div className="uber-node-holder linktype">
                                <span style={{width: "45px", display: "inline-block"}}>Spread:</span>
                                <Dropdown
                                    nostyle
                                    values={{1:"1",2:"2",3:"3",4:"4",5:"5"}}
                                    default={node.value}
                                    onChange={val=>{node.value=parseInt(val); this.setState({data: this.props.data}, ()=>{this.props.executeSearch()})}}
                                />
                                {dragBtnJSX}
                                {closeBtnJSX}
                                {inputJSX}
                                {outputJSX}
                            </div>
                        </foreignObject>
                    </g>
                )
                break
            case 'group':
                bb.width=150
                return (
                    <g
                        ref={c=>node._refs.holder=d3.select(c)}
                        className="uber-node-holder"
                    >
                        <foreignObject
                            x={node.x} y={node.y}
                            width={bb.width+40}
                            height={bb.height+40}
                            ref={c=>node._refs.fobj=d3.select(c)}
                        >
                            <div className="uber-node-holder groupp">
                                Group:
                                <input
                                    ref={c=>node._refs.textInput=d3.select(c)}
                                    spellCheck="false"
                                    type="text"
                                    xmlns="http://www.w3.org/1999/xhtml"
                                    placeholder="Type name..."
                                    value={this.state.data.value}
                                    onChange={e=>{this.props.data.value=e.target.value; this.setState({data: this.props.data}, ()=>{this.props.executeSearch()})}}
                                />
                                {dragBtnJSX}
                                {closeBtnJSX}
                                {inputJSX}
                                {outputJSX}
                            </div>
                        </foreignObject>
                    </g>
                )
                break
            default:
                console.log("ERROR!!")
                return null
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/UberNode.js